function Message(props) {
    return (
        <div className="flex flex-col h-full items-center justify-center bg-slate-50 border-slate-100 border-4 p-8 rounded">
			<div className="text-orange-500 font-bold text-4xl mb-2 uppercase">{props.title}</div>
            <div classname="text-gray-400 font-medium text-sm md:text-xl lg:text-2xl">{props.message}</div>
        </div>
    );
}

export default Message;